import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { HttpClient } from "@services/http";
import { AccountStorage } from "@services/account";
var _httpClient = /*#__PURE__*/new WeakMap();
var _accountStorage = /*#__PURE__*/new WeakMap();
export var LoginService = /*#__PURE__*/function () {
  function LoginService() {
    _classCallCheck(this, LoginService);
    _classPrivateFieldInitSpec(this, _httpClient, new HttpClient({
      useSpinner: false
    }));
    _classPrivateFieldInitSpec(this, _accountStorage, new AccountStorage());
  }
  return _createClass(LoginService, [{
    key: "siginIn",
    value: function () {
      var _siginIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params,
          URL,
          paramsData,
          resultSource,
          data,
          dataInfo,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              URL = "/pjyy-deepexi-user-center/api/v1/common/login";
              paramsData = {
                account: "",
                password: "",
                verifyCode: "",
                loginSource: "PC",
                loginSystem: "MALL",
                loginType: "ACCOUNT",
                remember: false
              };
              paramsData = Object.assign(paramsData, params);
              _context.next = 6;
              return _classPrivateFieldGet(_httpClient, this).post(URL, paramsData);
            case 6:
              resultSource = _context.sent;
              data = resultSource.data;
              if (data.code === "200") {
                dataInfo = data.data;
                if (paramsData.remember) {
                  _classPrivateFieldGet(_accountStorage, this).setCacheAccountId(paramsData.account, paramsData.verifyCode, paramsData.password);
                } else {
                  _classPrivateFieldGet(_accountStorage, this).setCacheAccountId(paramsData.account, paramsData.verifyCode);
                }
                _classPrivateFieldGet(_accountStorage, this).setCacheUserInfo(dataInfo);
                _classPrivateFieldGet(_accountStorage, this).setCacheLastAccountId(params.account);
              }
              return _context.abrupt("return", data);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function siginIn() {
        return _siginIn.apply(this, arguments);
      }
      return siginIn;
    }()
  }]);
}();